/* @flow */
import CenteredContainer from 'components/CenteredContainer.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import * as React from 'react';

/**
 * ## [LoadingIndicator](/internal/components/LoadingIndicator) wrapped in a [CenteredContainer](/internal/components/CenteredContainer).
 * ### In order for vertical centering to occur, its parent must have an explicitly set height (a min-height is not sufficient).
 *
 * ```example
 * <CenteredLoadingIndicator />
 * ```
 *
 *
 * # TODO
 * * Reconcile with other loaders
 */

class CenteredLoadingIndicator extends React.Component<{}> {
  render() {
    return (
      <CenteredContainer className="CenteredLoadingIndicator-container">
        <LoadingIndicator align="center" />
      </CenteredContainer>
    );
  }
}

export default CenteredLoadingIndicator;
